module.exports = __webpack_public_path__ + "img/modify_mobile.728b2378.svg";